import React, { FC } from 'react';
import { SVGProps } from '@utils';
import { SvgWrapper } from './SvgWrapper';

interface OpenListProps extends SVGProps {
  isOpen?: boolean;
}

export const OpenList: FC<OpenListProps> = ({ onClick, divClassName, isOpen=false }) => (
  <SvgWrapper
    divClassName={divClassName}
    onClick={onClick}
  >
    <svg 
      style={{ transform: `rotateX(${isOpen ? 180 : 0}deg)`}}
      width="13" 
      height="6" 
      viewBox="0 0 13 6" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        d="M6.5 6L0 0H13L6.5 6Z" 
        fill="#A0A4AC"
      />
    </svg>
  </SvgWrapper>
);
